export const UI_CONFIG = {

    table: {
        container:
            "bg-white dark:bg-table-bgDark rounded-table shadow-table",

        header:
            "bg-table-header dark:bg-table-headerDark text-table-text dark:text-table-textDark text-tableHeader font-semibold",

        row:
            "border-b border-table-border dark:border-table-borderDark hover:bg-table-hover dark:hover:bg-table-hoverDark",

        cell:
            "text-tableCell text-table-text dark:text-table-textDark px-tableX py-tableY",

        headerCell:
            "px-tableX py-tableX text-left",
    },

    button: {
        primary:
            "bg-brand-primary text-white px-4 py-2 rounded hover:bg-brand-secondary",
    },

    input: {
        search:
            "border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-200 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-primary",
    },

};